import React, { useState } from 'react';
import { LayoutDashboard, Heart, History, Settings, ArrowLeft, Send, Paperclip, Phone, MoreVertical } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link, useParams } from 'react-router-dom';
import { MessageModal } from '../../components/modals/MessageModal';
export function InquiryDetailPage() {
  const {
    id
  } = useParams();
  const [message, setMessage] = useState('');
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: '',
    message: '',
    type: 'info' as 'success' | 'error' | 'info'
  });
  const [showOptionsMenu, setShowOptionsMenu] = useState(false);
  const handleSendMessage = () => {
    if (!message.trim()) {
      setModalContent({
        title: 'Empty Message',
        message: 'Please type a message before sending.',
        type: 'error'
      });
      setIsMessageModalOpen(true);
      return;
    }
    setModalContent({
      title: 'Message Sent',
      message: 'Your message has been sent successfully. The seller will be notified.',
      type: 'success'
    });
    setIsMessageModalOpen(true);
    setMessage('');
  };
  const handleAttachment = () => {
    setModalContent({
      title: 'Attach File',
      message: 'File attachment feature is coming soon. You will be able to attach documents, images, and PDFs.',
      type: 'info'
    });
    setIsMessageModalOpen(true);
  };
  const handleRequestCall = () => {
    setModalContent({
      title: 'Call Request Sent',
      message: 'Your call request has been sent to Rajesh Kumar. They will contact you within 24 hours.',
      type: 'success'
    });
    setIsMessageModalOpen(true);
  };
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard'
  }, {
    label: 'Shortlisted Plots',
    icon: Heart,
    path: '/buyer/shortlisted'
  }, {
    label: 'My Inquiries',
    icon: History,
    path: '/buyer/inquiries'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/buyer/settings'
  }];
  return <DashboardLayout title="Buyer Dashboard" navItems={navItems} userInitials="JD" data-id="element-2986">
      <div className="flex flex-col h-[calc(100vh-140px)]" data-id="element-2987">
        <div className="mb-4 flex items-center justify-between" data-id="element-2988">
          <Link to="/buyer/inquiries" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#1f2933]" data-id="element-2989">
            <ArrowLeft className="w-4 h-4" data-id="element-2990" /> Back to Inquiries
          </Link>
          <div className="relative" data-id="element-2991">
            <button onClick={() => setShowOptionsMenu(!showOptionsMenu)} className="text-xs font-bold text-gray-500 hover:text-[#1f2933] flex items-center gap-1" data-id="element-2992">
              <MoreVertical className="w-4 h-4" data-id="element-2993" /> Options
            </button>
            {showOptionsMenu && <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 shadow-lg z-10" data-id="element-2994">
                <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50" data-id="element-2995">
                  Mark as Resolved
                </button>
                <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50" data-id="element-2996">
                  Archive Conversation
                </button>
                <button className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50" data-id="element-2997">
                  Report Seller
                </button>
              </div>}
          </div>
        </div>

        <div className="flex flex-1 border border-gray-300 bg-white overflow-hidden" data-id="element-2998">
          {/* Chat Area */}
          <div className="flex-1 flex flex-col border-r border-gray-300" data-id="element-2999">
            <div className="p-4 border-b border-gray-300 bg-gray-50 flex justify-between items-center" data-id="element-3000">
              <div data-id="element-3001">
                <h2 className="font-bold text-lg" data-id="element-3002">Rajesh Kumar</h2>
                <p className="text-xs text-gray-500" data-id="element-3003">
                  Seller • Last active: 10m ago
                </p>
              </div>
              <button onClick={handleRequestCall} className="flex items-center gap-2 px-3 py-1.5 border border-gray-300 bg-white text-xs font-bold hover:bg-gray-50" data-id="element-3004">
                <Phone className="w-3 h-3" data-id="element-3005" /> Request Call
              </button>
            </div>

            <div className="flex-1 p-6 overflow-y-auto space-y-6 bg-[#f9f9fb]" data-id="element-3006">
              <div className="flex justify-end" data-id="element-3007">
                <div className="bg-[#1f2933] text-white p-4 rounded-tl-lg rounded-bl-lg rounded-br-lg max-w-[80%]" data-id="element-3008">
                  <p className="text-sm" data-id="element-3009">
                    Hi, I'm interested in the Premium Corner Plot in Hinjewadi.
                    Is the price negotiable?
                  </p>
                  <span className="text-[10px] text-gray-400 mt-1 block text-right" data-id="element-3010">
                    Yesterday, 10:30 AM
                  </span>
                </div>
              </div>

              <div className="flex justify-start" data-id="element-3011">
                <div className="bg-white border border-gray-200 p-4 rounded-tr-lg rounded-br-lg rounded-bl-lg max-w-[80%]" data-id="element-3012">
                  <p className="text-sm text-gray-800" data-id="element-3013">
                    Hello! Yes, the price is slightly negotiable for immediate
                    closure. Are you looking for investment or self-use?
                  </p>
                  <span className="text-[10px] text-gray-400 mt-1 block" data-id="element-3014">
                    Yesterday, 10:45 AM
                  </span>
                </div>
              </div>

              <div className="flex justify-end" data-id="element-3015">
                <div className="bg-[#1f2933] text-white p-4 rounded-tl-lg rounded-bl-lg rounded-br-lg max-w-[80%]" data-id="element-3016">
                  <p className="text-sm" data-id="element-3017">
                    Investment purpose. Also, has the NA conversion been
                    completed recently? Can you share the documents?
                  </p>
                  <span className="text-[10px] text-gray-400 mt-1 block text-right" data-id="element-3018">
                    Yesterday, 11:00 AM
                  </span>
                </div>
              </div>

              <div className="flex justify-start" data-id="element-3019">
                <div className="bg-white border border-gray-200 p-4 rounded-tr-lg rounded-br-lg rounded-bl-lg max-w-[80%]" data-id="element-3020">
                  <p className="text-sm text-gray-800" data-id="element-3021">
                    Yes, NA conversion was done in 2023. I've attached the
                    certificate below.
                  </p>
                  <div className="mt-3 p-2 bg-gray-50 border border-gray-200 flex items-center gap-2 rounded-sm" data-id="element-3022">
                    <Paperclip className="w-4 h-4 text-gray-400" data-id="element-3023" />
                    <span className="text-xs font-mono text-blue-600 underline cursor-pointer" data-id="element-3024">
                      NA_Certificate_2023.pdf
                    </span>
                  </div>
                  <span className="text-[10px] text-gray-400 mt-1 block" data-id="element-3025">
                    Yesterday, 11:15 AM
                  </span>
                </div>
              </div>
            </div>

            <div className="p-4 border-t border-gray-300 bg-white" data-id="element-3026">
              <div className="flex gap-2" data-id="element-3027">
                <button onClick={handleAttachment} className="p-2 text-gray-400 hover:text-gray-600" data-id="element-3028">
                  <Paperclip className="w-5 h-5" data-id="element-3029" />
                </button>
                <input type="text" placeholder="Type your message..." value={message} onChange={e => setMessage(e.target.value)} onKeyPress={e => e.key === 'Enter' && handleSendMessage()} className="flex-1 border border-gray-300 p-2 text-sm focus:outline-none focus:border-gray-500 rounded-sm" data-id="element-3030" />
                <button onClick={handleSendMessage} className="p-2 bg-[#1f2933] text-white rounded-sm hover:bg-gray-800" data-id="element-3031">
                  <Send className="w-4 h-4" data-id="element-3032" />
                </button>
              </div>
            </div>
          </div>

          {/* Plot Details Sidebar */}
          <div className="w-80 bg-gray-50 p-6 hidden lg:block overflow-y-auto" data-id="element-3033">
            <h3 className="font-bold text-sm uppercase text-gray-500 mb-4" data-id="element-3034">
              Plot Details
            </h3>
            <div className="bg-white border border-gray-200 p-4 mb-6" data-id="element-3035">
              <div className="aspect-video bg-gray-100 mb-3 border border-dashed border-gray-300" data-id="element-3036"></div>
              <h4 className="font-bold text-sm mb-1" data-id="element-3037">Premium Corner Plot</h4>
              <p className="text-xs text-gray-500 mb-2" data-id="element-3038">
                Hinjewadi Phase 1, Pune
              </p>
              <p className="font-bold text-lg" data-id="element-3039">₹ 45 Lakhs</p>
              <Link to="/listing/1" className="block mt-3 text-center py-2 border border-gray-300 text-xs font-bold hover:bg-gray-50" data-id="element-3040">
                View Listing
              </Link>
            </div>

            <h3 className="font-bold text-sm uppercase text-gray-500 mb-4" data-id="element-3041">
              Status
            </h3>
            <div className="space-y-2" data-id="element-3042">
              <button className="w-full py-2 bg-green-600 text-white text-xs font-bold hover:bg-green-700" data-id="element-3043">
                Mark as Resolved
              </button>
              <button className="w-full py-2 border border-red-300 text-red-600 text-xs font-bold hover:bg-red-50" data-id="element-3044">
                Report Seller
              </button>
            </div>
          </div>
        </div>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title={modalContent.title} message={modalContent.message} type={modalContent.type} data-id="element-3045" />
    </DashboardLayout>;
}